module.exports = __webpack_public_path__ + "static/media/planet.77149d68.svg";